import { AxiosResponse } from 'axios';
import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithInfiniteQuery } from 'jotai-tanstack-query';

import { getUserFeedsApi } from '@flipster/apis/v1/user';
import { GetUserFeedsResponse } from '@flipster/apis/v1/user/types';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { getLocalStorage, setLocalStorage } from '@flipster/utils/localStorage';

import { profileBunja } from '../../bunja';

export const profileFeedQueryKey = 'getUserFeedsApi';
const profileFeedCount = 20;
export const profileFeedBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { resolvedProfileIdAtom } = bunja.use(profileBunja);
  const feedBaseAtom = atomWithInfiniteQuery((get) => {
    const profileId = get(resolvedProfileIdAtom);
    return {
      queryKey: [profileFeedQueryKey, profileId],
      queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
        getUserFeedsApi(profileId, { after: pageParam, count: profileFeedCount }),
      enabled: !!profileId,
      initialPageParam: undefined,
      getNextPageParam: (lastPage: AxiosResponse<GetUserFeedsResponse>) => {
        return lastPage.data.feedItems.at(-1)?.feedId;
      },
      refetchOnMount: true,
    };
  });
  const isPendingAtom = atom((get) => get(feedBaseAtom).isPending);
  const hasNextPageAtom = atom((get) => get(feedBaseAtom).hasNextPage);
  const feedAtom = atom((get) => get(feedBaseAtom).data?.pages.flatMap((page) => page.data.feedItems));
  async function fetchNextPage() {
    const { hasNextPage, fetchNextPage: fetch } = store.get(feedBaseAtom);
    if (!hasNextPage) return;
    await fetch();
  }
  return { feedAtom, fetchNextPage, isPendingAtom, hasNextPageAtom };
});

export const profileFeedNudgeBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const key = 'flipster.configs.v1.profile.feedTabRedDot';
  const feedNudgeBaseAtom = atom(false);
  const feedNudgeAtom = atom(
    (get) => get(feedNudgeBaseAtom),
    (_, set) => (setLocalStorage(key, false), set(feedNudgeBaseAtom, false)),
  );
  bunja.effect(() => {
    store.set(feedNudgeBaseAtom, getLocalStorage(key) ?? true);
  });
  return {
    feedNudgeAtom,
    removeFeedRedDot() {
      store.set(feedNudgeAtom);
    },
  };
});
